import { useSyncExternalStore } from 'react';

import { Breakpoint, media } from '../media';

type MediaKey = keyof typeof media;

let listeners: Array<VoidFunction> = [];

const mediaState = {
  sm: false,
  md: false,
  lg: false,
  xl: false,
  maxSm: false,
  maxMd: false,
  maxLg: false,
  maxXl: false,
};

if (window.matchMedia) {
  for (const [key, mediaQuery] of Object.entries(media)) {
    const listener = (event: MediaQueryListEvent) => {
      mediaState[key as MediaKey] = event.matches;
      listeners.forEach((l) => l());
    };

    const mediaQueryList = window.matchMedia(mediaQuery);
    mediaState[key as MediaKey] = mediaQueryList.matches;
    mediaQueryList.addEventListener('change', listener);
  }
}

function subscribe(callback: VoidFunction) {
  listeners.push(callback);

  return () => {
    listeners = listeners.filter((l) => l !== callback);
  };
}

function getSnapshot(breakpoint: Breakpoint) {
  return mediaState[breakpoint];
}

/**
 * Prefer using CSS media queries.
 */
export function useMatchMedia(breakpoint: Breakpoint) {
  const match = useSyncExternalStore(subscribe, () => getSnapshot(breakpoint));
  return match;
}
